import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router";
import { ProtectedRoute } from "@/shared/components/ProtectedRoute";
import { ErrorBoundary } from "@/shared/components/ErrorBoundary";
import { CardSkeleton, AppVersion } from "@/shared/components/ui";
import { env } from "@/config/env";

const RegisterPage = lazy(() =>
  import("@/pages/RegisterPage").then((module) => ({ default: module.RegisterPage }))
);
const LoginPage = lazy(() =>
  import("@/pages/LoginPage").then((module) => ({ default: module.LoginPage }))
);
const ForgotPasswordPage = lazy(() =>
  import("@/pages/ForgotPasswordPage").then((module) => ({ default: module.ForgotPasswordPage }))
);
const ResetPasswordPage = lazy(() =>
  import("@/pages/ResetPasswordPage").then((module) => ({ default: module.ResetPasswordPage }))
);
const VerifyEmailPage = lazy(() =>
  import("@/pages/VerifyEmailPage").then((module) => ({ default: module.VerifyEmailPage }))
);
const NotFoundPage = lazy(() =>
  import("@/pages/NotFoundPage").then((module) => ({ default: module.NotFoundPage }))
);
const AuthCallbackPage = lazy(() =>
  import("@/pages/AuthCallbackPage").then((module) => ({ default: module.AuthCallbackPage }))
);
const AccountActivationPage = lazy(() =>
  import("@/pages/AccountActivationPage").then((module) => ({
    default: module.AccountActivationPage,
  }))
);

const ConsentPage = lazy(() =>
  import("@/pages/ConsentPage").then((module) => ({ default: module.ConsentPage }))
);

const HomePage = lazy(() =>
  import("@/pages/HomePage").then((module) => ({ default: module.HomePage }))
);

function AuthLayout() {
  return (
    <div className="bg-page-grid flex min-h-screen items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <Suspense fallback={<CardSkeleton />}>
          <Outlet />
        </Suspense>
      </div>
      <div className="fixed right-0 bottom-4 left-0">
        <AppVersion />
      </div>
    </div>
  );
}

export function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route element={<AuthLayout />}>
            <Route index element={<LoginPage />} />
            <Route element={<LoginPage />} path="/login" />
            {env.features.emailLogin && env.features.register && (
              <Route element={<RegisterPage />} path="/register" />
            )}
            {env.features.emailLogin && (
              <Route element={<ForgotPasswordPage />} path="/forgot-password" />
            )}
            {env.features.emailLogin && (
              <Route element={<ResetPasswordPage />} path="/reset-password" />
            )}
            {env.features.emailLogin && (
              <Route element={<VerifyEmailPage />} path="/verify-email" />
            )}
            <Route element={<AuthCallbackPage />} path="/auth/callback" />
            <Route element={<AccountActivationPage />} path="/account-activation" />
            <Route element={<ConsentPage />} path="/consent" />

            <Route element={<NotFoundPage />} path="*" />
          </Route>

          <Route element={<ProtectedRoute />}>
            <Route
              element={
                <Suspense fallback={null}>
                  <HomePage />
                </Suspense>
              }
              path="/home"
            />
          </Route>
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
